import React from "react";
import { Box, Dialog, Slide, Typography } from "@material-ui/core";
import { TripDetails, FareDetails, Airport } from "redmond";
import {
  ActionButton,
  MixedCabinToolTip,
  ButtonWrap,
  CloseButtonIcon,
  removeTimezone,
} from "halifax";
import clsx from "clsx";
import * as constants from "./constants";
import "./styles.scss";
import { ReviewFlightDetails } from "../../../ReviewFlightDetails";
import { getSliceIndex } from "../../../../../../../../utils/flights";

interface IDesktopFlightReviewDetailsPopoverProps {
  departure: boolean;
  tripDetails: TripDetails;
  fareDetails: FareDetails;
  openPopover: boolean;
  onClose?: () => void;
  onClickEdit?: () => void;
  airports: { [key: string]: Airport };
  isMixedCabinClass?: boolean;
  disableChangeFlight: boolean;
}

export const DesktopFlightReviewDetailsPopover = (
  props: IDesktopFlightReviewDetailsPopoverProps
) => {
  const {
    departure,
    tripDetails,
    fareDetails,
    openPopover,
    onClose,
    onClickEdit,
    airports,
    isMixedCabinClass,
    disableChangeFlight,
  } = props;
  const sliceIndex = getSliceIndex(departure, tripDetails);
  const tripSlice = tripDetails.slices[sliceIndex];

  const renderHeader = (header: string) => {
    const [fromHeader, dateHeader] = header.split(":");
    return (
      <Typography variant="body1" className="flight-details-header">
        <span className="from">{fromHeader}</span>
        <span className="date">{dateHeader}</span>
        {isMixedCabinClass && <MixedCabinToolTip />}
      </Typography>
    );
  };

  const renderReviewDetails = () => {
    const header = constants.getSummaryPanelHeader(
      departure,
      airports[tripSlice.destinationCode]
        ? airports[tripSlice.destinationCode].cityName
        : tripSlice.destinationName,
      removeTimezone(tripSlice.departureTime),
      true
    );

    return (
      <Box className="pkg-review-desktop-flight-review-details-root">
        <Box className="desktop-flight-review-details-container">
          <Box className="header-section">
            <Box
              className="header-text"
              id="review-flight-details-header"
              tabIndex={-1}
            >
              {renderHeader(header)}
            </Box>
            {!disableChangeFlight && !!onClickEdit && (
              <ActionButton
                className="change-flight-button-wrapper"
                buttonClassName="change-flight-button"
                defaultStyle="h4r-secondary"
                message={constants.CHANGE_FLIGHT_TEXT}
                ariaLabelText={
                  departure
                    ? constants.CHANGE_OUTBOUND_FLIGHT_TEXT
                    : constants.CHANGE_RETURN_FLIGHT_TEXT
                }
                onClick={onClickEdit}
              />
            )}
          </Box>
          <Box className="content-section">
            <ReviewFlightDetails
              isOutgoing={sliceIndex === 0}
              fareDetails={fareDetails}
              isMixedCabinClass={isMixedCabinClass}
            />
          </Box>
        </Box>
      </Box>
    );
  };

  return (
    <Dialog
      hideBackdrop={false}
      TransitionComponent={Slide}
      TransitionProps={{
        /* eslint-disable */
        // @ts-ignore: Fix the type definition of TransitionProps to include direction.
        direction: "up",
        /* eslint-enable */
        role: "none",
      }}
      PaperProps={{
        /* eslint-disable */
        // @ts-ignore: Fix the type definition of PaperProps to include tabIndex.
        tabIndex: 0,
        /* eslint-enable */
      }}
      className={clsx(
        "desktop-popover-card-root",
        "pkg-review-desktop-flight-review-details-popup"
      )}
      onClick={(event) => {
        event.stopPropagation();
      }}
      role="dialog"
      aria-labelledby="review-flight-details-header"
      open={openPopover}
      onClose={onClose}
      invisibleBackdrop={false}
    >
      <Box className={clsx("desktop-popover-card-top-button", "right")}>
        <ButtonWrap aria-label="Close" onClick={onClose}>
          <CloseButtonIcon />
        </ButtonWrap>
      </Box>
      {renderReviewDetails()}
    </Dialog>
  );
};
